function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m225.999-45.001h60v412.001h-60z",
  fill: "#c5d3de",
  transform: "matrix(0 -1 1 0 94.999 416.999)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#f9f9f9"
}, /*#__PURE__*/React.createElement("path", {
  d: "m166 96h180v370h-180z",
  transform: "matrix(0 -1 1 0 -25 537)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m349.999 71v60h-300l40-60z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m201 191h110v40h-110z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m284.232 471h-56.464c-4.767 0-8.739-3.987-9.135-9.17l-17.633-230.83h110l-17.633 230.83c-.396 5.183-4.367 9.17-9.135 9.17z",
  fill: "#99ebfa"
}), /*#__PURE__*/React.createElement("path", {
  d: "m352 191h110v40h-110z",
  fill: "#f9f9f9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m435.232 471h-56.464c-4.767 0-8.739-3.987-9.135-9.17l-17.633-230.83h110l-17.633 230.83c-.396 5.183-4.367 9.17-9.135 9.17z",
  fill: "#60a4ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m50 191h110v40h-110z",
  fill: "#f9f9f9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m133.232 471h-56.464c-4.767 0-8.739-3.987-9.135-9.17l-17.633-230.83h110l-17.633 230.83c-.396 5.183-4.367 9.17-9.135 9.17z",
  fill: "#bfdbff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m350 61h40v70h-40z",
  fill: "#6d92ac"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 141h40v40h-40z",
  fill: "#6d92ac",
  transform: "matrix(0 1 -1 0 191 131)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m462 141h40v40h-40z",
  fill: "#6d92ac",
  transform: "matrix(0 1 -1 0 643 -321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m410 41h-20v90h60v-50c0-22.091-17.909-40-40-40z",
  fill: "#f9f9f9"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 202.89,
  cy: 71,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "m502 131h-30c0-5.523-4.478-10-10-10h-2v-40c0-27.57-22.43-50-50-50h-20c-5.522 0-10 4.477-10 10v10h-30c-5.522 0-10 4.477-10 10h-92.11c-5.52 0-10 4.49-10 10s4.48 10 10 10h92.11v40h-271.32l26.67-40h62.54c5.51 0 10-4.49 10-10s-4.49-10-10-10h-67.89c-3.351 0-6.46 1.67-8.32 4.45 0 0-40 60-40 60-1.084 1.625-1.681 3.595-1.681 5.55h-29.999c-5.522 0-10 4.477-10 10v40c0 5.523 4.478 10 10 10 0 0 29.999 0 30 .019 0 0-.006 40.255 0 40.393.005.117 17.662 231.179 17.662 231.179.787 10.323 9.18 18.409 19.106 18.409h56.465c9.926 0 18.318-8.086 19.105-18.408l6.233-81.592h43.859l6.233 81.591c.787 10.323 9.18 18.409 19.105 18.409h56.465c9.926 0 18.318-8.086 19.105-18.408l6.233-81.592h43.859l6.233 81.591c.787 10.323 9.18 18.409 19.105 18.409h56.465c9.926 0 18.318-8.086 19.105-18.408 0 0 17.657-231.063 17.662-231.18.006-.138 0-40.412 0-40.412h30c5.522 0 10-4.477 10-10v-40c0-5.523-4.478-10-10-10zm-462 40h-20v-20h20zm360-110v-10h10c16.542 0 30 13.458 30 30v40h-40zm-40 10h20v50h-20zm-227.599 390h-54.802l-16.806-220h88.414zm17.599-240h-90v-20h90zm10.098 140s9.897-129.471 9.902-129.588c.006-.138 0-30.412 0-30.412h21s.015 30.274.021 30.412c.005.117 9.881 129.588 9.881 129.588zm123.303 100h-54.803l-16.806-220h88.414zm17.599-240h-90v-20h90zm10.098 140s9.897-129.471 9.902-129.588c.006-.138 0-30.412 0-30.412h21s-.006 30.274 0 30.412c.005.117 9.902 129.588 9.902 129.588zm123.303 100h-54.803l-16.806-220h88.414zm17.599-240h-90v-20h90zm0-40h-392v-40h392zm40-10h-20v-20h20z"
})));

var SvgFiltration = function SvgFiltration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFiltration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filtration.23ba94c4.svg";
export { ForwardRef as ReactComponent };